import { EventStageAttributes } from '@/types'
import { CreateEventStageMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'

interface Props {
  eventId: string
  onSuccess: () => void
}

export const Form = ({ eventId, onSuccess }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading
  } = useForm<CreateEventStageMutation, EventStageAttributes, never, never>({
    defaultValues: {
      eventId,
      name: '',
      notes: '',
    },
    mutation: CreateMutation,
    resultKey: 'createEventStage',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
      { formBuilder.buildField({ name: 'Notes', field: 'notes', type: 'textarea' }) }
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
